import React, { useState } from 'react'
import { Drawer, Card, Alert } from 'antd'
import { useDispatch } from 'react-redux'
import { getAllCreditLimitListFxn } from '../actions/user'
import { TableComp } from 'sz-react-utils-lite'
import { DefaultTablePagination, displayDate, fixed2Digit } from '../../../components/_utils/appUtils'
import { xTravelWorldUrl } from '../../../settings'

const AllCreditLimitListDrawer = (props) => {
  let dispatch = useDispatch()
  let { onClose, visible, agentId, name, companyName, creditLimit } = props
  let tableRef = React.createRef()

  let apiRequest = (params) => {
    return new Promise(async (resolve) => {
      params.agentId = agentId
      params.note = 'Amount transferred from admin'
      let resp = await dispatch(getAllCreditLimitListFxn({
        ...params
      }))
      resolve(resp.data)
    })
  }
  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 20,
      render: (val, record, index) => {
        return index + 1
      }
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: 30,
      render: (item, record) => {
        let { ticketId } = record
        return (
          <>
            {item ? displayDate(item) : ''}
            {ticketId && ticketId._id ? <div>
              {ticketId && (ticketId.responseStatus || ticketId.bookingStatus) ?
                <a
                  href={`${xTravelWorldUrl}/x-travel/eTicket?ticketId=${ticketId._id}&firstName=${ticketId.Passengers[0].FirstName}&lastName=${ticketId.Passengers[0].LastName}`}
                  target={'_blank'}
                  className={'btn btn-primary mt-2 sm'}>Ticket </a> :
                <a href={`/error-page/${ticketId._id}`} target={'_blank'}
                   className={'btn btn-primary mt-2 sm'}>Error </a>}
            </div> : null}
          </>
        )
      }
    },
    {
      title: 'Credit',
      dataIndex: 'amount',
      key: 'credit',
      width: 50,
      render: (amount, record) =>
        record.transactionType === 'Credit' && (
          <div className={'text-success fw-bold'}>
            ₹ {fixed2Digit(amount)}
          </div>
        )
    },
    {
      title: 'Description',
      dataIndex: 'note',
      key: 'note',
      width: 100
    }
  ]

  return (
    <Drawer
      visible={visible}
      title={`All Transactions (Credit Limit: Rs.${fixed2Digit(creditLimit)})`}
      onClose={onClose}
      width={'50%'}>
      <div className={'card'}>
        <div className='card-body table-responsive'>
          <Alert message={`Agent - ${name} (${companyName})`} type='info' />
          <TableComp columns={columns}
                     ref={tableRef}
                     bordered={true}
                     pagination={DefaultTablePagination()}
                     apiRequest={apiRequest}
          />
        </div>
      </div>
    </Drawer>
  )
}
export default AllCreditLimitListDrawer
